import { CustomAddress } from '../../interfaces/address.interface';
import { Employee } from '../employee/employee.model';
import { BaseModel } from '../_base/model.class';

export class Supplier extends BaseModel {
  constructor(
    private _id?: string,
    private name?: string,
    private companyName?: string,
    private vatNumber?: string,
    private taxCode?: string,
    private legalAddress?: CustomAddress,
    private operativeAddress?: CustomAddress,
    private categories?: string,
    private verified?: boolean,
    private contactPerson?: string,
    private pec?: string,
    private email?: string,
    private phone?: string,
    private fax?: string,
    private webSiteUrl?: string,
    private properties?: string[],
    private companies?: string[],
    private employees?: Employee[],
    private vc?: string,
    private durc?: string,
    private dvr?: string,
    private rspp?: string,
    private ris?: string,
    private pos?: string,
    private createdBy?: string,
    private createdAt?: Date,
    private updatedBy?: string,
    private updatedAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'name',
      'vatNumber',
      'legalAddress',
      'categories',
      // 'properties',
      'verified',
      'createdBy',
      'createdAt',
    ]);
  }

  /**
   * Check if supplier is verified or not
   *
   * @since 1.0.0
   */
  isVerified(): boolean {
    return this.verified;
  }
}
